import { render, staticRenderFns } from "./DataCalendar.vue?vue&type=template&id=73b61a67&scoped=true"
import script from "./DataCalendar.vue?vue&type=script&lang=js"
export * from "./DataCalendar.vue?vue&type=script&lang=js"
import style0 from "./DataCalendar.vue?vue&type=style&index=0&id=73b61a67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b61a67",
  null
  
)

export default component.exports